<template>
    <div >
        <div class="updateBox">
        <el-upload
        class="upload-demo"
        action='zw56-zhb-ess-server/zhbess/zhbdata/uploadSendCarData'
        :on-change="handleChange"
        :file-list="fileList">
        <el-button size="small" type="primary">导入派车</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <el-upload
        class="upload-demo"
        action="zw56-zhb-ess-server/zhbess/zhbdata/uploadJianJinData"
        :on-change="handleChange2"
        :file-list="fileList2">
        <el-button size="small" type="primary">导入检斤</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <el-upload
        class="upload-demo"
        action="zw56-zhb-ess-server/zhbess/zhbdata/uploadCheXiaoData"
        :on-change="handleChange3"
        :file-list="fileList3">
        <el-button size="small" type="primary">导入撤销</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <el-upload
        class="upload-demo"
        action="zw56-zhb-ess-server/zhbess/zhbdata/SteelWeightService"
        :on-change="handleChange4"
        :file-list="fileList4">
        <el-button size="small" type="primary">钢厂检斤</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <el-upload
        class="upload-demo"
        action="zw56-zhb-ess-server/zhbess/zhbdata/purchasePlan"
        :on-change="handleChange5"
        :file-list="fileList5">
        <el-button size="small" type="primary">钢厂采购计划</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <!-- <el-upload
        class="upload-demo"
        action="zw56-zhb-ess-server/zhbess/ZhbWebTest/loadDetail"
        :on-change="handleChange6"
        :file-list="fileList6">
        <el-button size="small" type="primary">装车单</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload> -->
        </div>
    </div>
</template>
<script>
// import { update } from '@/api/zhb'
export default {
  data () {
    return {
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: []
    }
  },
  methods: {
    handleChange (file, fileList) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange2 (file, fileList2) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange3 (file, fileList3) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange4 (file, fileList4) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange5 (file, fileList5) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange6 (file, fileList6) {
      //   this.fileList = fileList.slice(-3)
    }
  }
}
</script>
<style>
.updateBox{
    margin-left: 15px;
}
</style>
